import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

const Menu = () => {
  const [activeDay, setActiveDay] = useState("Monday");
  const [menuItems, setMenuItems] = useState({});

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "menu"));
        const items = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        console.log("Fetched Menu Items:", items);

        // Group by day
        const grouped = items.reduce((acc, item) => {
          const day = item.day || "Monday";
          if (!acc[day]) acc[day] = [];
          acc[day].push(item);
          return acc;
        }, {});

        setMenuItems(grouped);
      } catch (error) {
        console.error("Error fetching menu:", error);
      }
    };

    fetchMenu();
  }, []);

  const menuData = menuItems[activeDay] || [];

  return (
    <div className="weekly-menu-container">
      <div className="weekly-menu-header">
        <h2>
          Our <span className="highlight">Weekly</span> Menu
        </h2>
        <p>
          Explore our diverse weekly menu featuring a variety of delicious
          homemade dishes. Menu changes every week.
        </p>
      </div>

      {/* Day Tabs */}
      <div className="day-tabs">
        {[
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ].map((day) => (
          <button
            key={day}
            className={`day-tab ${activeDay === day ? "active" : ""}`}
            onClick={() => setActiveDay(day)}
          >
            {day}
          </button>
        ))}
      </div>

      {/* Menu Cards */}
      <div className="menu-sections">
        <div className="menu-cards-container">
          {menuData.length > 0 ? (
            menuData.map((item) => (
              <div key={item.id} className="menu-card">
                {/* Image handling */}
                <div className="menu-card-images">
                  {item.images &&
                  Array.isArray(item.images) &&
                  item.images.length > 0 ? (
                    item.images.map((img, index) => (
                      <img
                        key={index}
                        src={typeof img === "string" ? img : img.url}
                        alt={`${item.name}-${index}`}
                        className="menu-card-image"
                      />
                    ))
                  ) : (
                    <img
                      src={
                        item.image ||
                        item.imgUrl ||
                        item.imageURL ||
                        item.url ||
                        "https://via.placeholder.com/300x200?text=No+Image"
                      }
                      alt={item.name}
                      className="menu-card-image"
                    />
                  )}
                </div>
                <span
                  className={
                    item.veg === true || item.veg === "true" || item.veg === 1
                      ? "veg-badge"
                      : "non-veg-badge"
                  }
                >
                  {item.veg === true || item.veg === "true" || item.veg === 1
                    ? "Veg"
                    : "Non-Veg"}
                </span>

                {/* Content */}
                <div className="menu-card-content">
                  <h4>{item.name}</h4>
                  <p>{item.shortDesc || "Delicious homemade food."}</p>

                  <div className="item-details">
                    <span>Rating: ⭐ {item.rating || "4.0"}</span>
                    <span>Price: ₹ {item.price}</span>
                    <button
                      className="view-details-btn"
                      disabled={!item.available}
                    >
                      {item.available ? "Order Now →" : "Out of Stock"}
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500">No items available for {activeDay}.</p>
          )}
        </div>
      </div>

      {/* CTA */}
      <div className="custom-menu-cta">
        <div className="cta-content">
          <h3>Want Your Customised Menu?</h3>
          <p>
            Are you tired of searching for good catering services in your area?
            We can help you cater to your needs! Click on the button below and
            send us your requirements. Our executive will get back to you as
            possible.
          </p>
          <button
            className="cta-button"
            onClick={() => (window.location.href = "/contact")}
          >
            Contact Us Now
          </button>
        </div>
      </div>

      {/* Your CSS remains the same */}
      <style jsx>{`
        .weekly-menu-container {
          font-family: "Poppins", sans-serif;
          padding: 4rem 2rem;
          background-color: #f7f3f0;
          color: #333;
        }

        .weekly-menu-header {
          text-align: center;
          margin-bottom: 2rem;
          margin-top: 3rem;
        }

        .weekly-menu-header h2 {
          font-size: 2.5rem;
          font-weight: 700;
          margin: 0;
        }

        .weekly-menu-header .highlight {
          color: #f97316;
        }

        .weekly-menu-header p {
          color: #666;
          max-width: 600px;
          margin: 0.5rem auto 0;
        }

        .day-tabs {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-bottom: 3rem;
        }

        .day-tab {
          padding: 0.75rem 1.5rem;
          border-radius: 9999px;
          border: 1px solid transparent;
          background-color: #fff;
          color: #f97316;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }

        .day-tab:hover {
          background-color: #f97316;
          color: #fff;
          transform: translateY(-2px);
        }

        .day-tab.active {
          background-color: #f97316;
          color: #fff;
          border-color: #f97316;
        }

        .menu-sections {
          display: flex;
          flex-direction: column;
          gap: 3rem;
        }

        .menu-cards-container {
          display: flex;
          flex-wrap: wrap;
          gap: 2rem;
          justify-content: center;
        }

        .menu-card {
          background-color: #fff;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          width: 300px;
          position: relative;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: pointer;
        }

        .menu-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
        }

        .menu-card-images {
          display: flex;
          gap: 0.5rem;
          padding: 0.5rem;
          overflow-x: auto;
        }

        .menu-card-images img {
          width: 100%;
          height: 180px;
          object-fit: cover;
          border-radius: 8px;
        }

        .veg-badge,
        .non-veg-badge {
          position: absolute;
          top: 8px;
          right: 8px;
          background-color: #22c55e;
          color: #fff;
          padding: 0.25rem 0.75rem;
          border-radius: 9999px;
          font-size: 0.8rem;
          font-weight: 600;
        }

        .non-veg-badge {
          background-color: #dc2626;
        }

        .menu-card-content {
          padding: 1.5rem;
        }

        .menu-card-content h4 {
          font-size: 1.125rem;
          font-weight: 600;
          margin: 0 0 0.5rem;
        }

        .menu-card-content p {
          font-size: 0.875rem;
          color: #666;
          line-height: 1.4;
          margin: 0 0 0.5rem;
        }

        .item-details {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }

        .item-details span {
          font-size: 0.875rem;
          color: #444;
        }

        .view-details-btn {
          padding: 0.5rem 1rem;
          border: 1px solid #f97316;
          color: #f97316;
          background-color: transparent;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.3s ease;
          margin-top: 0.5rem;
        }

        .view-details-btn:disabled {
          background-color: #ccc;
          color: #888;
          border-color: #ccc;
          cursor: not-allowed;
        }

        .view-details-btn:hover:not(:disabled) {
          background-color: #f97316;
          color: #fff;
        }

        .custom-menu-cta {
          background-color: #f3e6d8;
          padding: 2rem;
          border-radius: 12px;
          text-align: center;
          margin-top: 4rem;
        }

        .cta-content {
          max-width: 700px;
          margin: 0 auto;
        }

        .cta-content h3 {
          font-size: 1.75rem;
          font-weight: 700;
          color: #ea580c;
        }

        .cta-content p {
          font-size: 1rem;
          color: #555;
          margin-bottom: 1.5rem;
        }

        .cta-button {
          background-color: #f97316;
          color: #fff;
          padding: 0.75rem 1.5rem;
          border: none;
          border-radius: 9999px;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .cta-button:hover {
          background-color: #ea580c;
        }

        @media (max-width: 768px) {
          .weekly-menu-container {
            padding: 4rem 1rem;
          }

          .day-tabs {
            justify-content: flex-start;
            overflow-x: auto;
            white-space: nowrap;
            padding-bottom: 1rem;
          }

          .menu-cards-container {
            flex-direction: column;
            align-items: center;
            gap: 1.5rem;
          }

          .menu-card {
            width: 100%;
            max-width: 350px;
          }

          .custom-menu-cta {
            padding: 1.5rem;
          }

          .menu-card-images {
            display: flex;
            gap: 0.5rem;
            overflow-x: auto;
          }

          .menu-card-images img {
            width: 90px;
            height: 90px;
            border-radius: 8px;
            object-fit: cover;
          }
        }
      `}</style>
    </div>
  );
};

export default Menu;
